export default "__VITE_ASSET__B6pqVdf7__"